import type { User } from '@libs/contexts';
import { ui } from '@libs/domain';
import { RestClient } from '@libs/rest-client';
import { Menu } from '@mui/material';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router-dom';
import { UserMenuItem } from './UserMenuItem';

interface UserMenuProps {
  user: User;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function UserMenu(props: UserMenuProps) {
  const { user, anchorEl, setAnchorEl } = props;
  const navigate = useNavigate();
  const getLinkName = useItemNames(ui.linkNames);

  return (
    <Menu
      anchorEl={anchorEl}
      id="user-menu"
      open={Boolean(anchorEl)}
      onClick={() => setAnchorEl(null)}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transitionDuration={0}
      MenuListProps={{
        disablePadding: true,
      }}
    >
      {(user.type === 'ROOT' || user.isAdmin) && (
        <UserMenuItem
          id="manage-system"
          name={getLinkName('toSystemManagement')}
          onClick={() => navigate('/system-management/main-menu')}
        />
      )}
      <UserMenuItem
        id="change-password"
        name={getLinkName('changePassword')}
        onClick={() => {
          navigate('/user/change-password');
        }}
      />
      <UserMenuItem
        id="logout"
        name={getLinkName('logout')}
        onClick={async () => {
          try {
            await RestClient.auth.post('/logout');
          } catch (error) {
            console.debug(error);
          } finally {
            navigate('/');
          }
        }}
      />
    </Menu>
  );
}
